import * as actionTypes from '../types/actionTypes'

export const dropData = (data) => {
  return {
    type: actionTypes.DROPDOWN_VALUES,
    payload: data
  }
}
